import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const errMsg = (e) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === "string" ? e.response.data.detail : "تحقق من البيانات المدخلة")
  : "حدث خطأ، حاول مرة أخرى";
